import UserAccountCircleLine from './user-account-circle-line.component.js'

export * from './user-account-circle-line.component.js'
export default UserAccountCircleLine

UserAccountCircleLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-account-circle-line': UserAccountCircleLine
  }
}
